module.exports = __webpack_public_path__ + "media/images/arrow-white-76a8bb40a949b4002b63c17ec8984259.svg";